import React from 'react';

const ExtractionMethodSelector = ({ extractionMethod, setExtractionMethod }) => (
  <div className="mb-2">
    <div className="accordion accordion-flush" id="extractionMethodAccordion">
      <div className="accordion-item">
        <h2 className="accordion-header" id="extractionMethodHeading">
          <button
            className="accordion-button collapsed py-2 px-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#extractionMethodCollapse"
            aria-expanded="false"
            aria-controls="extractionMethodCollapse"
          >
            <i className="bi bi-robot me-2 text-primary"></i>
            <span className="fw-semibold">Método de Extracción</span>
            <span className="badge bg-primary ms-2 text-uppercase">
              {extractionMethod === 'ocr_text' ? 'Rápido' : 'Preciso'}
            </span>
          </button>
        </h2>
        <div
          id="extractionMethodCollapse"
          className="accordion-collapse collapse"
          aria-labelledby="extractionMethodHeading"
          data-bs-parent="#extractionMethodAccordion"
        >
          <div className="accordion-body px-0 py-3">
            <fieldset>
              <legend className="form-label fw-small mb-3 text-center w-100">¿Qué método de extracción deseas usar?</legend>
              
              {/* Toggle Switch personalizado */}
              <div className="d-flex justify-content-center mb-3">
                <div className="extraction-method-toggle d-flex align-items-center bg-light rounded-pill p-1 position-relative" style={{minWidth: '280px', height: '50px'}}>
                  {/* Slider background animado */}
                  <div 
                    className={`position-absolute rounded-pill transition-all ${
                      extractionMethod === 'ocr_text' ? 'bg-success' : 'bg-primary'
                    }`}
                    style={{
                      width: '50%',
                      height: 'calc(100% - 8px)',
                      top: '4px',
                      left: extractionMethod === 'ocr_text' ? '4px' : '50%',
                      transition: 'all 0.3s ease',
                      zIndex: 1
                    }}
                  />
                  
                  {/* Opción Rápido */}
                  <label 
                    htmlFor="extractionMethodOcr"
                    className={`flex-fill text-center py-2 px-3 position-relative fw-medium cursor-pointer ${
                      extractionMethod === 'ocr_text' ? 'text-white' : 'text-muted'
                    }`}
                    style={{zIndex: 2, cursor: 'pointer', transition: 'color 0.3s ease'}}
                  >
                    <i className="bi bi-lightning-charge me-1"></i>
                    Rápido
                  </label>
                  
                  {/* Opción Preciso */}
                  <label 
                    htmlFor="extractionMethodImage"
                    className={`flex-fill text-center py-2 px-3 position-relative fw-medium cursor-pointer ${
                      extractionMethod === 'image' ? 'text-white' : 'text-muted'
                    }`}
                    style={{zIndex: 2, cursor: 'pointer', transition: 'color 0.3s ease'}}
                  >
                    <i className="bi bi-bullseye me-1"></i>
                    Preciso
                  </label>
                  
                  {/* Inputs ocultos pero accesibles */}
                  <input
                    type="radio"
                    name="extractionMethod"
                    id="extractionMethodOcr"
                    value="ocr_text"
                    checked={extractionMethod === 'ocr_text'}
                    onChange={e => setExtractionMethod(e.target.value)}
                    aria-describedby="ocr-description"
                    className="visually-hidden"
                  />
                  <input
                    type="radio"
                    name="extractionMethod"
                    id="extractionMethodImage"
                    value="image"
                    checked={extractionMethod === 'image'}
                    onChange={e => setExtractionMethod(e.target.value)}
                    aria-describedby="image-description"
                    className="visually-hidden"
                  />
                </div>
              </div>
            </fieldset>
            <div className="mt-2">
              {extractionMethod === 'ocr_text' ? (
                <div id="ocr-description" className="alert alert-success py-2 px-3 mb-2 text-muted">
                  <i className="bi bi-lightning-charge-fill me-1 text-success"></i>
                  <strong>Método Rápido (OCR):</strong> Extrae texto directamente de documentos. 
                  <ul className="mb-1 mt-1 ps-3">
                    <li><strong>Velocidad:</strong> ⚡ Procesamiento rápido (2-5 segundos)</li>
                    <li><strong>Consumo:</strong> 💰 Menor costo por documento</li>
                    <li><strong>Ideal para:</strong> Facturas simples, recibos, certificados con texto claro</li>
                  </ul>
                  <small className="text-success fw-medium">✅ Recomendado para documentos bien escaneados y estructurados</small>
                </div>
              ) : (
                <div id="image-description" className="alert alert-primary py-2 px-3 mb-2 text-muted">
                  <i className="bi bi-bullseye me-1 text-primary"></i>
                  <strong>Método Preciso (Vision AI):</strong> Analiza documentos como imágenes completas.
                  <ul className="mb-1 mt-1 ps-3">
                    <li><strong>Velocidad:</strong> 🐌 Procesamiento más lento (10-30 segundos)</li>
                    <li><strong>Consumo:</strong> 💰💰 Mayor costo por documento</li>
                    <li><strong>Ideal para:</strong> Formularios complejos, documentos con sellos, imágenes borrosas</li>
                  </ul>
                  <small className="text-primary fw-medium">🎯 Recomendado para documentos complejos o de baja calidad</small>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ExtractionMethodSelector;
